import React, { Component } from "react";
import { Calendar } from "@progress/kendo-react-dateinputs";

class KendoCalendar extends Component {

    onChange = (e) => {
        if (this.props.onChange !== undefined) {
            this.props.onChange(e);
        }
    }

    render() {
        return <Calendar onChange={this.onChange} />;
    }
}
export default KendoCalendar;